export default function (value) {
  if (!value)
    return true;

  let values = value.split('/').reverse().map(Number);

  if (values.length !== 3)
    return false;

  if (!(values[1] >= 1 && values[1] <= 12 && values[2] >= 1 && values[2] <= 31))
    return false;

  let date = new Date(values[0], values[1] - 1, values[2]);

  if (date.getMonth() !== values[1] - 1)
    return false;

  return !(Object.prototype.toString.call(date) !== '[object Date]' || isNaN(date.getTime()));
};
